import React, { Component } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ViewAccountList from "./ViewAccountList.js";
import UpdateAccount from "./UpdateAccount.js";
import OrgAccount from "./OrgAccount.js";
import CloudAccountsTable from "./CloudAccountsTable.js";
import EditAccountDialog from "./EditAccountDialog.js";
import {
  getListOfAccts,
  getListOfOrgsAndAccts,
  clearAllOrgAccountMessages,
  getPricingInfo,
  clearAllAwsAccMessages,
  registerOrgAccountSuccessful,
} from "../../store/actions";
import { clearAllAccountConfigurationMessages } from "../../store/accountConfiguration/accountConfigurationSlice";
import { clearOrganizationalUnits } from "../../store/multiAccountOnboard/multiAccountSlice";
import { connect } from "react-redux";
import AddOnsManagement from "./AddonsManagement";
import { enqueueSnackbar } from "notistack";

import UpdateIamRole from "./UpdateIamRole.js";
import SubscriptionModal from "./SubscriptionManagement/SubscriptionModal.js";
import { Tooltip, IconButton, Typography, Box, Divider, List, ListItem, ListItemText, Paper } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import azureLighthouseLogo from "../../assets/images/azure_lighthouse_logo.png";
import MultipleAccountsForm from "./MultipleAccountsForm";
import { getAccountCloudType } from "../../CloudProviderContext";
import {
  OPEN_PAIR_ACCOUNT_EVENT,
  OPEN_PAIR_ACCOUNT_STORAGE_KEY,
} from "../../helpers/pairAccountNavigation";
import { AccountDetailThemeProvider } from "./accountDetailTheme";

class AccountDetailPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      modal_static: false,
      modal_addons: false,
      editAcctModal: false,
      editRoleModal: false,
      notifyDelete: false,
      isOpen: false,
      tooltipOpen: false,
      numAccounts: this.props.licensing.numAccounts,
      isLicensingInfoOpen: false,
      selectedLicense: null,
      accountInformation: null,
      licenseData: null,
      accounts: null,
      editAccountCode: null,
      addAccountTab: '1',
      currentStep: 1, // Track current step for side panel
      sidePanelOpen: true, // Track side panel visibility
      selectedAccountType: "", // Cloud provider selected in Add Account Step 1
      showMultipleAccountsTab: false, // AWS-only; shown after advancing past cloud select
      azureLighthouseJson: null, // Lighthouse template JSON for Azure pairing side panel
      lighthouseCopySuccess: false,
      lighthouseEditorExpanded: false,
      azureFetchDetailsComplete: false, // Show Step 7 in side panel after successful Fetch
    };
    this.multipleAccountsFormRef = React.createRef();
  }

  handleStepChange = (step) => {
    this.setState((prevState) => {
      const next = { currentStep: step };
      // Only update multi-account tab visibility from the Add Account wizard step
      if (prevState.addAccountTab === "1") {
        if (prevState.selectedAccountType === "AWS") {
          next.showMultipleAccountsTab = true;
        }
        if (step === 1 && prevState.selectedAccountType !== "AWS") {
          next.showMultipleAccountsTab = false;
        }
      }
      return next;
    });
  };

  handleAccountTypeChange = (accountType) => {
    this.setState((prevState) => ({
      selectedAccountType: accountType,
      ...(accountType === "AWS"
        ? { showMultipleAccountsTab: true }
        : {
            showMultipleAccountsTab: false,
            ...(prevState.addAccountTab === "2"
              ? {
                  addAccountTab: "1",
                  currentStep:
                    prevState.currentStep >= 1 ? prevState.currentStep : 1,
                }
              : {}),
          }),
    }));
  };

  handleSidePanelClose = () => {
    this.setState({ sidePanelOpen: false });
  };

  handleSidePanelOpen = () => {
    this.setState({ sidePanelOpen: true });
  };

  handleAzureLighthouseJsonChange = (jsonText) => {
    this.setState({
      azureLighthouseJson: jsonText || null,
      lighthouseCopySuccess: false,
    });
  };

  handleAzureFetchDetailsComplete = (complete) => {
    this.setState({ azureFetchDetailsComplete: !!complete });
  };

  handleCopyLighthouseJson = () => {
    const { azureLighthouseJson } = this.state;
    if (!azureLighthouseJson) return;
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(azureLighthouseJson).then(() => {
        this.setState({ lighthouseCopySuccess: true });
        setTimeout(
          () => this.setState({ lighthouseCopySuccess: false }),
          3000
        );
      });
    }
  };

  handleDownloadLighthouseJson = () => {
    const { azureLighthouseJson } = this.state;
    if (!azureLighthouseJson) return;
    const blob = new Blob([azureLighthouseJson], {
      type: "application/json;charset=utf-8",
    });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "lighthouse-pairing-template.json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(a.href);
  };

  getAddAccountStepInfo = () => {
    const {
      currentStep,
      addAccountTab,
      selectedAccountType,
      azureLighthouseJson,
    } = this.state;

    if (addAccountTab === "1") {
      if (currentStep < 1 || currentStep > 5) return null;
      return OrgAccount.getStepInformation(currentStep, selectedAccountType, {
        azureTemplateReady: !!azureLighthouseJson,
      });
    }

    if (addAccountTab === "2") {
      if (currentStep < 1 || currentStep > 2) return null;
      return MultipleAccountsForm.getStepInformation(currentStep);
    }

    return null;
  };

  getUpdateAccountStepInfo = () => {
    const editAcct = this.props.accounts?.find(
      (account) => account.accountCode === this.state.editAccountCode
    );
    return UpdateAccount.getStepInformation(getAccountCloudType(editAcct));
  };

  isGuideSidePanelActive = () => {
    const { isOpen, addAccountTab } = this.state;
    return isOpen && (addAccountTab === "1" || addAccountTab === "2");
  };

  renderCollapsedSidePanelTab = () => {
    if (!this.isGuideSidePanelActive()) {
      return null;
    }

    return (
      <Tooltip title="Show guide" placement="left" arrow>
        <Box
          component="button"
          type="button"
          onClick={this.handleSidePanelOpen}
          aria-label="Show account setup guide"
          sx={{
            position: "fixed",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 1051,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.75,
            width: 40,
            minHeight: 120,
            px: 0.5,
            py: 1.5,
            border: "1px solid #e0e0e0",
            borderRight: "none",
            borderRadius: "10px 0 0 10px",
            backgroundColor: "#fff",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
            cursor: "pointer",
            color: "#193A6F",
            transition: "background-color 0.2s ease, box-shadow 0.2s ease",
            "&:hover": {
              backgroundColor: "#f8fafc",
              boxShadow: "0 6px 20px rgba(0, 0, 0, 0.16)",
            },
          }}
        >
          <ChevronLeftIcon sx={{ fontSize: 22 }} />
          <Typography
            sx={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
              fontSize: "0.75rem",
              fontWeight: 600,
              letterSpacing: "0.06em",
              color: "#334155",
              userSelect: "none",
            }}
          >
            Guide
          </Typography>
        </Box>
      </Tooltip>
    );
  };

  renderSidePanel = () => {
    const {
      currentStep,
      addAccountTab,
      sidePanelOpen,
      selectedAccountType,
      azureLighthouseJson,
      lighthouseCopySuccess,
      azureFetchDetailsComplete,
      editAcctModal,
    } = this.state;
    
    // Pair Account wizard or Update Account edit dialog
    if (!this.isGuideSidePanelActive()) {
      return null;
    }

    if (!sidePanelOpen) {
      return this.renderCollapsedSidePanelTab();
    }

    const stepInfo = editAcctModal
      ? this.getUpdateAccountStepInfo()
      : this.getAddAccountStepInfo();
    if (!stepInfo || !stepInfo.steps || stepInfo.steps.length === 0) {
      return null;
    }

    const showLighthouseEditor =
      !editAcctModal &&
      addAccountTab === "1" &&
      selectedAccountType === "AZURE" &&
      currentStep === 3 &&
      !!azureLighthouseJson;

    const guideSubtitle = editAcctModal
      ? stepInfo.subtitle ||
        "Review and update this account's details."
      : addAccountTab === "1"
        ? currentStep === 1
          ? "Choose AWS or Azure to begin adding an account."
          : `Follow these steps to add ${
              selectedAccountType === "AZURE"
                ? "an Azure"
                : selectedAccountType === "AWS"
                  ? "an AWS"
                  : "a cloud"
            } account.`
        : "Follow these steps to onboard linked accounts.";

    return (
      <Box
          sx={{
            position: "fixed",
            right: 0,
            top: 0,
            height: "100vh",
            width: { xs: 320, sm: 380, md: 420, lg: 480 },
            backgroundColor: "#fff",
            boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.3)",
            border: "1px solid #e0e0e0",
            zIndex: 1051,
            overflow: "auto",
          }}
        >
          <Paper
            elevation={0}
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                p: 3,
                borderBottom: "1px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <Box sx={{ flex: 1, pr: 1 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#333",
                    fontSize: "18px",
                    mb: 1,
                  }}
                >
                  {stepInfo.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "13px", lineHeight: 1.4 }}
                >
                  {guideSubtitle}
                </Typography>
              </Box>
              <Tooltip title="Hide guide" placement="left" arrow>
                <IconButton
                  onClick={this.handleSidePanelClose}
                  aria-label="Hide account setup guide"
                  sx={{
                    color: "#666",
                    "&:hover": {
                      backgroundColor: "#e0e0e0",
                      color: "#333",
                    },
                  }}
                >
                  <ChevronRightIcon />
                </IconButton>
              </Tooltip>
            </Box>

            {/* Content */}
            <Box
              sx={{
                flex: 1,
                p: 2,
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                overflow: "auto",
              }}
            >
              {(() => {
                const isMainStepText = (step) => {
                  const isSubStep = step.startsWith("  ");
                  const stepText = isSubStep ? step.trim() : step;
                  return (
                    !isSubStep &&
                    !stepText.match(/^[a-z]\./) &&
                    !stepText.match(/^[A-Z]\./) &&
                    !stepText.match(/^[ivx]+\./) &&
                    !stepText.match(/^[IVX]+\./)
                  );
                };

                // Place JSON editor after main step 1 (and its sub-steps), before step 2
                let insertEditorAfterIndex = -1;
                if (showLighthouseEditor) {
                  let mainStepCounter = 0;
                  for (let i = 0; i < stepInfo.steps.length; i++) {
                    if (isMainStepText(stepInfo.steps[i])) {
                      mainStepCounter++;
                    }
                    if (mainStepCounter === 1) {
                      insertEditorAfterIndex = i;
                    }
                    if (mainStepCounter === 2) {
                      break;
                    }
                  }
                }

                const renderStepItems = (steps, startCounter = 0) => {
                  let mainStepCounter = startCounter;
                  return steps.map((step, index) => {
                    const isSubStep = step.startsWith("  ");
                    const stepText = isSubStep ? step.trim() : step;
                    const isMainStep = isMainStepText(step);

                    if (isMainStep) {
                      mainStepCounter++;
                    }

                    const stepNumber = isMainStep ? mainStepCounter : null;

                    return (
                      <React.Fragment key={`${startCounter}-${index}`}>
                        <ListItem
                          sx={{
                            px: 0,
                            py: 0.5,
                            alignItems: "flex-start",
                            pl: isSubStep ? 4 : 0,
                          }}
                        >
                          {isMainStep && stepNumber && (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 32,
                                height: 32,
                                borderRadius: "50%",
                                backgroundColor: "#f0f7ff",
                                border: "2px solid #1976d2",
                                mr: 2,
                                mt: 0.5,
                                flexShrink: 0,
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "#1976d2",
                                  fontWeight: 600,
                                  fontSize: "14px",
                                }}
                              >
                                {stepNumber}
                              </Typography>
                            </Box>
                          )}
                          {isSubStep && (
                            <Box sx={{ width: 32, mr: 2, flexShrink: 0 }} />
                          )}
                          <ListItemText
                            primary={
                              <Typography
                                variant="body2"
                                sx={{
                                  color: "text.secondary",
                                  fontSize: "13px",
                                  lineHeight: 1.6,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                {stepText}
                              </Typography>
                            }
                          />
                        </ListItem>
                        {index < steps.length - 1 &&
                          !steps[index + 1].startsWith("  ") &&
                          !steps[index + 1].trim().match(/^[a-z]\./) &&
                          !steps[index + 1].trim().match(/^[A-Z]\./) &&
                          !steps[index + 1].trim().match(/^[ivx]+\./) &&
                          !steps[index + 1].trim().match(/^[IVX]+\./) && (
                            <Divider
                              sx={{
                                ml: 6,
                                mr: 2,
                                borderColor: "#e0e0e0",
                              }}
                            />
                          )}
                      </React.Fragment>
                    );
                  });
                };

                const lighthouseEditor = showLighthouseEditor ? (
                  <Box
                    sx={{
                      mt: 1.5,
                      mb: 1.5,
                      flex: "0 0 auto",
                      ...(this.state.lighthouseEditorExpanded
                        ? { minHeight: 280, maxHeight: "45vh" }
                        : {}),
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "#1e1e1e",
                      borderRadius: "6px",
                      border: "1px solid #333",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 0.25,
                        px: 1,
                        pt: 0.25,
                        pb: 0.25,
                        flexShrink: 0,
                        backgroundColor: "#1e1e1e",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.75,
                          pl: 0.5,
                        }}
                      >
                        <img
                          src={azureLighthouseLogo}
                          alt="Azure Lighthouse"
                          title="Azure Lighthouse"
                          style={{
                            height: 18,
                            width: 18,
                            objectFit: "contain",
                            flexShrink: 0,
                          }}
                        />
                        <Typography
                          sx={{
                            color: "#d4d4d4",
                            fontSize: "12px",
                            fontWeight: 500,
                          }}
                        >
                          Lighthouse Template
                        </Typography>
                      </Box>
                      <Box sx={{ display: "flex", gap: 0.25 }}>
                        <Tooltip title={this.state.lighthouseEditorExpanded ? "Hide JSON" : "Show JSON"}>
                          <IconButton
                            size="small"
                            aria-label="Toggle Lighthouse JSON visibility"
                            onClick={() => this.setState((prev) => ({ lighthouseEditorExpanded: !prev.lighthouseEditorExpanded }))}
                            sx={{ color: "#d4d4d4" }}
                          >
                            {this.state.lighthouseEditorExpanded ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                          </IconButton>
                        </Tooltip>
                        <Tooltip
                          title={
                            lighthouseCopySuccess ? "Copied" : "Copy JSON"
                          }
                        >
                          <IconButton
                            size="small"
                            aria-label="Copy Lighthouse JSON"
                            onClick={this.handleCopyLighthouseJson}
                            sx={{ color: "#d4d4d4" }}
                          >
                            <ContentCopyIcon
                              fontSize="small"
                              color={
                                lighthouseCopySuccess ? "primary" : "inherit"
                              }
                            />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Download JSON">
                          <IconButton
                            size="small"
                            aria-label="Download Lighthouse JSON"
                            onClick={this.handleDownloadLighthouseJson}
                            sx={{ color: "#d4d4d4" }}
                          >
                            <DownloadIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Box>
                    {this.state.lighthouseEditorExpanded && (
                      <Box
                        component="pre"
                        sx={{
                          m: 0,
                          px: 1.5,
                          pb: 1.5,
                          pt: 0.5,
                          flex: 1,
                          minHeight: 0,
                          overflow: "auto",
                          color: "#d4d4d4",
                          fontFamily:
                            "Consolas, Monaco, 'Courier New', monospace",
                          fontSize: "12px",
                          lineHeight: 1.5,
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                        }}
                      >
                        {azureLighthouseJson}
                      </Box>
                    )}
                  </Box>
                ) : null;

                if (insertEditorAfterIndex >= 0) {
                  const stepsBefore = stepInfo.steps.slice(
                    0,
                    insertEditorAfterIndex + 1
                  );
                  const stepsAfter = stepInfo.steps.slice(
                    insertEditorAfterIndex + 1
                  );
                  return (
                    <>
                      <List sx={{ p: 0, flexShrink: 0 }}>
                        {renderStepItems(stepsBefore, 0)}
                      </List>
                      {lighthouseEditor}
                      {stepsAfter.length > 0 && (
                        <List sx={{ p: 0, flexShrink: 0 }}>
                          {renderStepItems(stepsAfter, 1)}
                        </List>
                      )}
                    </>
                  );
                }

                return (
                  <>
                    <List sx={{ p: 0, flexShrink: 0 }}>
                      {renderStepItems(stepInfo.steps, 0)}
                    </List>
                    {lighthouseEditor}
                  </>
                );
              })()}
              {azureFetchDetailsComplete && !editAcctModal && (
                <List sx={{ p: 0, flexShrink: 0, mt: showLighthouseEditor ? 1 : 0 }}>
                  <Divider
                    sx={{
                      ml: 6,
                      mr: 2,
                      my: 0.5,
                      borderColor: "#e0e0e0",
                    }}
                  />
                  <ListItem
                    sx={{
                      px: 0,
                      py: 0.5,
                      alignItems: "flex-start",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        backgroundColor: "#f0f7ff",
                        border: "2px solid #1976d2",
                        mr: 2,
                        mt: 0.5,
                        flexShrink: 0,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#1976d2",
                          fontWeight: 600,
                          fontSize: "14px",
                        }}
                      >
                        7
                      </Typography>
                    </Box>
                    <ListItemText
                      primary={
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontSize: "13px",
                            lineHeight: 1.6,
                          }}
                        >
                          Verify the details and hit Submit to create your new
                          Azure Account
                        </Typography>
                      }
                    />
                  </ListItem>
                </List>
              )}
            </Box>
          </Paper>
        </Box>
    );
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return { ...prevState, numAccounts: nextProps.licensing.numAccounts };
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handlePairDialogEscape);
    window.addEventListener(
      OPEN_PAIR_ACCOUNT_EVENT,
      this.handleOpenPairAccountRequest
    );
    this.consumeOpenPairAccountRequest();
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handlePairDialogEscape);
    window.removeEventListener(
      OPEN_PAIR_ACCOUNT_EVENT,
      this.handleOpenPairAccountRequest
    );
  }

  handleOpenPairAccountRequest = () => {
    this.openModal();
  };

  consumeOpenPairAccountRequest = () => {
    try {
      if (sessionStorage.getItem(OPEN_PAIR_ACCOUNT_STORAGE_KEY) === "1") {
        sessionStorage.removeItem(OPEN_PAIR_ACCOUNT_STORAGE_KEY);
        this.openModal();
      }
    } catch (e) {
      // ignore storage failures
    }
  };

  // Reactstrap only handles ESC when focus is inside the modal element.
  // The guide side panel sits outside the modal, so ESC must be handled at document level.
  handlePairDialogEscape = (e) => {
    if (!this.state.isOpen) return;
    if (e.key !== "Escape" && e.keyCode !== 27) return;
    e.preventDefault();
    this.closeModal();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.accounts !== this.props.accounts) {
      this.setState({ accounts: this.props.accounts });
    }
    if (this.props.pricingInfo && !this.state.licenseData) {
      this.setState({
        licenseData: this.props.pricingInfo["Subscription Model"],
      });
    }
  }

  toggleTab = (tab) => {
    if (this.state.addAccountTab !== tab) {
      this.setState({ addAccountTab: tab, currentStep: 1 });
    }
  };

  setNotifyDelete(status, row) {
    this.setState({
      ...this.state,
      notifyDelete: status,
      notifyDeleteRow: row,
    });
  }

  newAccountAdded = (accountCloudType) => {
    // Toggle (topbar) reads orgAccount via getListOfOrgsAndAccts — must refresh unfiltered.
    this.props.dispatchGetListOfOrgsAndAccts();
    // Configuration grid reads acctList via getListOfAccts (provider-scoped).
    const type =
      accountCloudType ||
      (this.props.isAzureView ? "AZURE" : "AWS");
    this.props.dispatchGetListOfAcctsForType(type);
    // Avoid closeModal overwriting acctList with the previous provider filter.
    this._skipNextCloseAcctsRefresh = true;
    if (
      accountCloudType &&
      typeof this.props.onAccountCloudTypeAdded === "function"
    ) {
      this.props.onAccountCloudTypeAdded(accountCloudType);
    }
  };

  updateData = () => {
    console.log("Update Data Called ***");
    if (this.props.postAccountConfigurationMessage) {
      console.log(
        "Calling getListOfAccts() from AccountDetailPolicy, updateData"
      );
      this.props.dispatchGetListOfAccts();
    }
    if (
      this.props.postAccountConfigurationMessage ||
      this.props.postAccountConfigurationError
    ) {
      this.props.clearAllAccountConfigurationMessages();
    }
  };

  closeModal = () => {
    // Stop polling if the ref exists
    if (this.multipleAccountsFormRef.current && 
        this.multipleAccountsFormRef.current.treeSelectorRef && 
        this.multipleAccountsFormRef.current.treeSelectorRef.current && 
        typeof this.multipleAccountsFormRef.current.treeSelectorRef.current.stopPolling === 'function') {
      this.multipleAccountsFormRef.current.treeSelectorRef.current.stopPolling();
    }

    // Only dispatch if we're closing addons modal and changes were made
    if (this.state.modal_addons && this.props.postAccountConfigurationMessage) {
      this.props.dispatchGetListOfAccts();
    }
    
    // Reset modal state and refresh datagrid
    this.setState({
      ...this.state,
      modal_static: false,
      modal_addons: false,
      editAcctModal: false,
      editRoleModal: false,
      isOpen: false,
      addAccountTab: '1', // Reset to first tab
      currentStep: 1, // Reset step for side panel
      sidePanelOpen: true, // Reset side panel to open when modal reopens
      selectedAccountType: "",
      showMultipleAccountsTab: false,
      azureLighthouseJson: null,
      lighthouseCopySuccess: false,
      azureFetchDetailsComplete: false,
    });
    
    // Refresh the datagrid unless newAccountAdded just refreshed for the paired cloud type
    if (this._skipNextCloseAcctsRefresh) {
      this._skipNextCloseAcctsRefresh = false;
    } else {
      this.props.dispatchGetListOfAccts();
    }
    
    // Clear all messages
    this.props.clearAllOrgAccountMessages();
    
    // Clear organizational units state to reset the modal completely
    this.props.dispatchClearOrganizationalUnits();
  };

  openModal = () => {
    const initialAccountType = this.props.isAzureView ? "AZURE" : "AWS";
    this.props.dispatchResetOrgAccountStatus();
    this.setState({
      isOpen: true,
      sidePanelOpen: true,
      selectedAccountType: initialAccountType,
      showMultipleAccountsTab: initialAccountType === "AWS",
      azureLighthouseJson: null,
      lighthouseCopySuccess: false,
      azureFetchDetailsComplete: false,
    });
  };

  closeModalview = () => this.setState({ isOpen: false });
  setTooltipOpen = (state) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        tooltipOpen: state,
      };
    });
  };

  openLicensingInfoModal = (selectedLicense, accountInformation) => {
    this.setState({
      isLicensingInfoOpen: true,
      selectedLicense: selectedLicense,
      accountInformation: accountInformation,
    });
  };
  closeLicensingInfoModal = () => {
    this.setState({
      isLicensingInfoOpen: false,
      licenseData: null,
      selectedLicense: null,
      accountInformation: null,
    });
  };

  handleUpgradeClick = (successMessage) => {
    enqueueSnackbar(successMessage, { variant: "success" });
    console.log(
      "Calling getListOfAccts() from AccountDetailPolicy, handleUpgradeClick"
    );
    this.props.dispatchGetListOfAccts();
    this.setState({ accounts: this.props.accounts });
  };

  handleAddonsUpgrade = (successMessage) => {
    console.log("Upgrade process initiated with Addons:");
    console.log("Before enqueueSnackbar");
    enqueueSnackbar(successMessage, { variant: "success" });
    console.log("After enqueueSnackbar");
    console.log(
      "Calling getListOfAccts() from AccountDetailPolicy, handleAddonsUpgrade"
    );
    this.props.dispatchGetListOfAccts();
    this.setState({ accounts: this.props.accounts });
    console.log("After Update");
  };

  handleAccountsAdded = () => {
    this.newAccountAdded("AWS");
    this.props.dispatchClearOrganizationalUnits();
    this.closeModal();
  };

  render() {
    console.log("AccountDetailPolicy is rendered");
    const editAcct = this.props.accounts.find(
      (account) => account.accountCode === this.state.editAccountCode
    );
    const complianceAddOns = this.props.accounts.find(
      (account) => account.accountCode === this.state.editAccountCode
    )?.complianceAddOns;
    const addOns = this.props.accounts.find(
      (account) => account.accountCode === this.state.editAccountCode
    )?.subscription?.addons;

    return (
      <AccountDetailThemeProvider>
      <React.Fragment>
        {this.renderSidePanel()}
        {this.state.isOpen && (
          <Modal 
            isOpen={this.state.isOpen} 
            size="lg" 
            centered
            toggle={this.closeModal}
          >
            <ModalHeader
              toggle={this.closeModal}
              style={{
                backgroundColor: "#F98125",
                margin: -1,
                display: "flex",
                alignItems: "center",
                minHeight: 56,
              }}
              close={
                <button
                  type="button"
                  aria-label="Close"
                  onClick={this.closeModal}
                  style={{
                    padding: 0,
                    margin: 0,
                    border: "none",
                    background: "transparent",
                    color: "#FFFFFF",
                    fontSize: 28,
                    fontWeight: 700,
                    lineHeight: 1,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    opacity: 1,
                    boxShadow: "none",
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              }
            >
              <Typography color="#FFFFFF" variant="h6">
                {this.state.selectedAccountType === "AZURE"
                  ? "Pair Subscription"
                  : "Pair Account"}
              </Typography>
            </ModalHeader>
            <ModalBody style={{ maxHeight: 'calc(100vh - 120px)', overflowY: 'auto', overflowX: 'hidden' }}>
              <div id="add-account-wizard-chrome" />
              {(this.state.addAccountTab === "2" ||
                this.state.currentStep === 1) && (
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={this.state.addAccountTab === '1' ? 'active' : ''}
                    onClick={() => this.toggleTab('1')}
                    style={{ cursor: 'pointer' }}
                  >
                    Add Account
                  </NavLink>
                </NavItem>
                {this.state.selectedAccountType === 'AWS' &&
                  this.state.showMultipleAccountsTab && (
                  <NavItem>
                    <NavLink
                      className={this.state.addAccountTab === '2' ? 'active' : ''}
                      onClick={() => this.toggleTab('2')}
                      style={{ cursor: 'pointer' }}
                    >
                      Add Multiple Accounts
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
              )}
              <TabContent activeTab={this.state.addAccountTab}>
                <TabPane tabId="1">
                  <OrgAccount
                    handleAddAccountsModal={this.closeModal}
                    newAccountAdded={this.newAccountAdded}
                    onStepChange={this.handleStepChange}
                    onAccountTypeChange={this.handleAccountTypeChange}
                    initialAccountType={
                      this.props.isAzureView ? "AZURE" : "AWS"
                    }
                    wizardChromeActive={this.state.addAccountTab === "1"}
                    onSidePanelOpen={this.handleSidePanelOpen}
                    onAzureLighthouseJsonChange={
                      this.handleAzureLighthouseJsonChange
                    }
                    onAzureFetchDetailsComplete={
                      this.handleAzureFetchDetailsComplete
                    }
                  />
                </TabPane>
                {this.state.selectedAccountType === 'AWS' &&
                  this.state.addAccountTab === '2' && (
                  <TabPane tabId="2">
                    <MultipleAccountsForm 
                      ref={this.multipleAccountsFormRef}
                      organizations={this.props.accounts} 
                      closeModal={this.closeModal}
                      onAccountsAdded={this.handleAccountsAdded}
                      onStepChange={this.handleStepChange}
                    />
                  </TabPane>
                )}
              </TabContent>
            </ModalBody>
          </Modal>
        )}
        {this.isGuideSidePanelActive() && this.state.sidePanelOpen && (
          <style>
            {`
              .modal.show {
                padding-right: 480px !important;
              }
              @media (max-width: 1400px) {
                .modal.show {
                  padding-right: 420px !important;
                }
              }
              @media (max-width: 1200px) {
                .modal.show {
                  padding-right: 380px !important;
                }
              }
              @media (max-width: 1024px) {
                .modal.show {
                  padding-right: 320px !important;
                }
              }
            `}
          </style>
        )}
        <CloudAccountsTable
          accounts={this.props.accounts || []}
          isAzureView={this.props.isAzureView}
          roleAccess={this.props.roleAccess}
          numAccounts={this.state.numAccounts}
          orgLicensing={this.props.orgLicensing}
          licensing={this.props.licensing}
          onPairAccount={this.openModal}
          onEditAccount={(acct) => {
            this.setState({
              editAcctModal: true,
              editAccountCode: acct.accountCode,
            });
          }}
          onDeleteAccount={(acct) => this.setNotifyDelete(true, acct)}
        />
        {this.state.modal_static && (
          <ViewAccountList
            modal_static={this.state.modal_static}
            closeModal={this.closeModal}
            accountCode={this.state.accountCode}
            accountNumber={this.state.accountNumber}
            userList={this.state.userList}
            key={`user-list-${this.state.accountCode}`}
          />
        )}

        {this.state.modal_addons && (
          <AddOnsManagement
            modal_addons={this.state.modal_addons}
            closeModal={this.closeModal}
            // accountCode={this.state.accountCode}
            // accountNumber={this.state.accountNumber}
            complianceAddOns={complianceAddOns || []}
            addOns={addOns || []}
            editAccount={editAcct}
            accounts={this.props.accounts}
            handleAddonsUpgrade={this.handleAddonsUpgrade}
          />
        )}

        {/* Rotate IAM Role */}
        <Modal
          isOpen={this.state.editRoleModal}
          size="lg"
          centered
          toggle={this.closeModal}
        >
          <ModalHeader
            toggle={this.closeModal}
            style={{
              backgroundColor: "#F98125",
              margin: -1,
              display: "flex",
              alignItems: "center",
              minHeight: 56,
            }}
            close={
              <button
                type="button"
                aria-label="Close"
                onClick={this.closeModal}
                style={{
                  padding: 0,
                  margin: 0,
                  border: "none",
                  background: "transparent",
                  color: "#FFFFFF",
                  fontSize: 28,
                  fontWeight: 700,
                  lineHeight: 1,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  opacity: 1,
                  boxShadow: "none",
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            }
          >
           <Typography color="#FFFFFF" variant="h6">
            {editAcct?.status === "ACTIVE" ? "Update IAM Role" : "Activate Account"}
          </Typography>
          </ModalHeader>
          <ModalBody>
            <UpdateIamRole
              externalId={this.props.organizations[0].externalid}
              selectedAccount={editAcct}
              addOns={addOns}
              closeModal={this.closeModal}
              key={editAcct?.accountCode}
            />
          </ModalBody>
        </Modal>
        {/* Edit Account */}
        <EditAccountDialog
          key={editAcct?.accountCode || "edit-account"}
          open={this.state.editAcctModal}
          onClose={this.closeModal}
          editAccount={editAcct}
          accounts={this.props.accounts}
          complianceAddOns={complianceAddOns || []}
          addOns={addOns || []}
          externalId={this.props.organizations?.[0]?.externalid}
          updateData={this.updateData}
        />
        {/* Delete account */}
        <Modal isOpen={this.state.notifyDelete} size="md" centered>
          <ModalHeader
            closeModal={this.closeModal}
            style={{ backgroundColor: "#F98125", margin: -1 }}
          >
            <Typography color="#FFFFFF" variant="h6">
              Delete Account
            </Typography>  
          </ModalHeader>
          <ModalBody>
            {this.state.notifyDeleteRow && (
              <>
                {[
                  {
                    name:
                      getAccountCloudType(this.state.notifyDeleteRow) === "AZURE"
                        ? "Subscription Name"
                        : "Account Name",
                    field: "accountName",
                  },
                  {
                    name:
                      getAccountCloudType(this.state.notifyDeleteRow) === "AZURE"
                        ? "Subscription ID"
                        : "Account Number",
                    field: "accountNumber",
                  },
                ].map((item) => {
                  return (
                    <div className="form-group row">
                      <label
                        htmlFor="isLicComplete"
                        className="col-sm-6 col-form-label"
                      >
                        {item.name}
                      </label>
                      <div className="col-sm-5">
                        {this.state.notifyDeleteRow[item.field]}
                      </div>
                    </div>
                  );
                })}
                Customer-enabled deletion is not available at the moment. Please
                email{" "}
                <a href="mailto:support.cloudcatcher@cloudnovatech.com">
                  support.cloudcatcher@cloudnovatech.com
                </a>{" "}
                to request deletion of this account.
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn w-lg btn-secondary"
              onClick={() => this.setNotifyDelete(false)}
            >
              Cancel
            </button>
          </ModalFooter>
        </Modal>
        {/* Modal to display Licensing Information */}
        <SubscriptionModal
          isOpen={this.state.isLicensingInfoOpen}
          toggle={this.closeLicensingInfoModal}
          handleUpgradeClick={this.handleUpgradeClick}
          accountInformation={this.state.accountInformation}
        />
        
      </React.Fragment>
      </AccountDetailThemeProvider>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    pricingInfo,
    error: pricingInfoApiError,
    loading: pricingInfoApiLoading,
    accountNumber,
  } = state.pricingInfo;

  const { organizations } = state.acctList;

  const { postAccountConfigurationMessage, postAccountConfigurationError } =
    state.accountConfiguration;

  const { awsAccountPosting, postAwsAccMessage, postAwsAccError } =
    state.awsAcc;

  return {
    pricingInfo,
    pricingInfoApiError,
    pricingInfoApiLoading,
    accountNumber,
    organizations,
    orgLicensing: state.licensing,
    postAccountConfigurationMessage,
    postAccountConfigurationError,

    awsAccountPosting,
    postAwsAccMessage,
    postAwsAccError,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    // Match Configuration page: fetch accounts for the active cloud provider
    dispatchGetListOfAccts: () => {
      dispatch(
        getListOfAccts({
          params: {
            accountType: ownProps.isAzureView ? "AZURE" : "AWS",
          },
        })
      );
    },
    dispatchGetListOfAcctsForType: (accountType) => {
      dispatch(
        getListOfAccts({
          params: {
            accountType: accountType === "AZURE" ? "AZURE" : "AWS",
          },
        })
      );
    },
    // Unfiltered accounts list powers the AWS/Azure header toggle (orgAccount store)
    dispatchGetListOfOrgsAndAccts: () => {
      dispatch(getListOfOrgsAndAccts());
    },
    clearAllOrgAccountMessages: () => {
      dispatch(clearAllOrgAccountMessages());
    },
    dispatchResetOrgAccountStatus: () => {
      dispatch(registerOrgAccountSuccessful(null));
    },
    getLicensePricingInfo: (accountNumber, subscription, orgCode) => {
      dispatch(getPricingInfo(accountNumber, subscription, orgCode));
    },
    clearAllAccountConfigurationMessages: () => {
      dispatch(clearAllAccountConfigurationMessages());
    },
    clearAllAwsAccMessages: () => {
      dispatch(clearAllAwsAccMessages());
    },
    dispatchClearOrganizationalUnits: () => {
      dispatch(clearOrganizationalUnits());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountDetailPolicy);
